import { useEffect, useState } from 'react';

export const useIsAppleDevice = (): boolean => {
    const [isApple, setIsApple] = useState(false);

    useEffect(() => {
        setIsApple(/iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
    }, []);

    return isApple;
}
